var exports = {
  "Lg": "GuildSidebarSkeleton.module__navigation___MnkwbG",
  "X9": "GuildSidebarSkeleton.module__detachedBanner___MnkwbG",
  "GG": "GuildSidebarSkeleton.module__topSpacer___MnkwbG",
  "dl": "GuildSidebarSkeleton.module__membersSection___MnkwbG",
  "ne": "GuildSidebarSkeleton.module__membersSeparator___MnkwbG",
  "vd": "GuildSidebarSkeleton.module__bottomDropZone___MnkwbG",
  "TN": "GuildSidebarSkeleton.module__groups___MnkwbG",
  "Os": "GuildSidebarSkeleton.module__group___MnkwbG",
  "nM": "GuildSidebarSkeleton.module__row___MnkwbG",
  "bQ": "GuildSidebarSkeleton.module__rowCategory___MnkwbG",
  "me": "GuildSidebarSkeleton.module__categoryCaret___MnkwbG",
  "et": "GuildSidebarSkeleton.module__rowChannel___MnkwbG",
  "Ec": "GuildSidebarSkeleton.module__rowMembers___MnkwbG",
  "p": "GuildSidebarSkeleton.module__channelIcon___MnkwbG",
  "US": "GuildSidebarSkeleton.module__bottomSpacer___MnkwbG",
};

module.exports = exports;
